<script>
import ModelIndex from "../models/index"

export default {
  extends: ModelIndex,
  page: {
    title: "Companies",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('companies.plural')) }},
    resourceRoute: {default: 'companies'},
    modelVariable: {default: 'company'}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('companies.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('companies.plural')),
          href: "/companies",
          active: true,
        },
      ],
      filterColumns: {
        name: { type: String, label: this.lodash.upperFirst(this.$t('companies.name')) },
        customers: { type: Array, label: this.lodash.upperFirst(this.$t('companies.customers')) },
      }
    }
  },
  computed: {
    columns() {
      return {
        ['company']: [
          { key: 'index', label: '#', sortable: false, style: { width: '1%' } },
          {
            key: 'name',
            label: this.lodash.upperFirst(this.$t('companies.name')),
            thStyle: { minWidth: '200px' },
            sortable: true,
            component: {
              props: ['item'],
              template: '<div style="width: 200px" class="text-truncate" :title="item.name">{{ item.name }}</div>'
            }
          },
          {
            key: 'address',
            label: this.lodash.upperFirst(this.$t('companies.address')),
            thStyle: { minWidth: '400px' },
            sortable: false,
            component: {
              props: ['item'],
              template: '<span style="white-space: pre">{{ item.address }}</span>'
            }
          },
          { key: 'action', class: 'text-center', style: { width: '1%' } }
        ],
      };
    },
  },
  methods: {
    delete(value) {
      return this.$axios.delete(`/companies/${this.getModelKey(value)}`)
    },
    fetchModels(page = 1) {
      return this.$axios.get('/companies', {
        params: {
          page: page,
          per_page: this.perPage,
          search: this.search,
          sort: `${this.sortBy},${this.sortDesc ? 'desc' : 'asc'}`,
          ...this.filterParams
        }
      }).then((response) => {
        const { data: { data, meta, aggregate = {} } } = response;
        this.models = data.map((datum) => ({
          ...datum,
          _denyShow: false,
          _denyEdit: false,
          _denyDelete: false
        }))
        this.page = Number(meta.current_page);
        this.perPage = Number(meta.per_page);
        this.from = Number(meta.from);
        this.total = Number(meta.total);

        this.stats = [
          {
            title: this.lodash.upperFirst(this.$t('companies.count')),
            value: this.$numeral(aggregate.count).format('0,0 a'),
            valueTitle: this.$numeral(aggregate.count).format('0,0'),
            icon: 'bx bx-buildings'
          }
        ]

        return response;
      }).catch((error) => this.failedAlert(error));
    }
  },
};
</script>
